module.exports = __webpack_public_path__ + "img/tag.33cc9fe5.svg";